import React from 'react';
import { Link, Stack, Text } from '@fluentui/react';
import { useNavigate } from 'react-router';
import confirmation from 'media/img/Confirmation.svg';
import IvicosStrings from '../kits/language/stringKit';
import { useLanguage } from '../components/context/LanguageContext';

const NewUserAwaitingConfirmation: React.FC<{}> = () => {
    const routeHistory = useNavigate();
    const { selectedLanguageOption }: any = useLanguage();

    return (
        <Stack>
            <Stack
                style={{
                    background: 'linear-gradient(150deg, #E4E3E4 41.98%, #E4E4E3 54.26%, rgba(255, 255, 255, 0.807062) 58.41%, #E4E4E3 62.45%, #E4E4E3 74.73%)',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100vh',
                    justifyContent: 'center'
                }}
            >
                <Stack
                    style={{
                        height: selectedLanguageOption === 'en' ? 503 : 533,
                        width: 375,
                        backgroundColor: '#fff',
                        boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
                        justifyContent: 'center'
                    }}
                >
                    <Stack
                        style={{
                            margin: 'auto',
                            height: selectedLanguageOption === 'en' ? 425 : 500,
                            width: 330
                        }}
                    >
                        <Stack
                            style={{
                                width: 70,
                                height: 70,
                                border: '1px solid #ffcc00',
                                borderRadius: '50%',
                                backgroundColor: '#ffcc00',
                                alignSelf: 'center',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden'
                            }}
                        >
                            <img
                                src={confirmation}
                                alt="awaiting-confirmation"
                                width={30}
                                height={30}
                                style={{
                                    display: 'block'
                                }}
                            />
                        </Stack>

                        <Text
                            variant="large"
                            style={{
                                marginTop: 33,
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}
                        >
                            {IvicosStrings.userConfirmationPageTitle}
                        </Text>
                        <Stack
                            style={{
                                textAlign: 'justify'
                            }}
                        >
                            <Text variant="medium" style={{ marginTop: 40 }}>
                                {IvicosStrings.userConfirmationPageDescription1}
                            </Text>
                            <Text variant="medium" style={{ marginTop: 40 }}>
                                {IvicosStrings.userConfirmationPageDescription3}
                            </Text>
                            <Text variant="medium" style={{ marginTop: 40 }}>
                                <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>{IvicosStrings.userConfirmationPageDescription4}</Text>
                                <br />
                                {IvicosStrings.userConfirmationPageDescription5}{' '}
                                <Link
                                    style={{ color: '#000', fontWeight: 700, textDecoration: 'underline' }}
                                    onClick={() => {
                                        routeHistory('/login');
                                        sessionStorage.setItem('showEmail', 'true');
                                        sessionStorage.setItem('useAlternativeEmailService', 'true');
                                    }}
                                >
                                    {IvicosStrings.here}
                                </Link>{' '}
                                {IvicosStrings.userConfirmationPageDescription6}
                            </Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default NewUserAwaitingConfirmation;
